import { render, staticRenderFns } from "./relation-info.vue?vue&type=template&id=648f4430"
import script from "./relation-info.vue?vue&type=script&lang=js"
export * from "./relation-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports